import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getCommentsByFinding } from '../../services/ruutsApi/findingComments/getCommentsByFinding'
import { saveComment } from '../../services/ruutsApi/findingComments/saveComment'
import type { SaveCommentParams } from '../../services/ruutsApi/findingComments/saveComment'
import { queryKeys } from './queryKeys'

export const useFindingComments = (findingId: string | undefined) =>
  useQuery({
    queryKey: queryKeys.findingComments(findingId),
    queryFn: ({ signal }) => getCommentsByFinding({ findingId: findingId as string, signal }),
    enabled: !!findingId,
  })

export const useSaveComment = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (params: SaveCommentParams) => saveComment(params),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.findingComments(variables.findingId) })
    },
  })
}
